import Icon from '$store/components/ui/Icon.tsx'
import Select from '$store/components/ui/Select.tsx'
import { ProductListingPage } from 'apps/commerce/types.ts'

const SORT_QUERY_PARAM = 'sort'

const portugueseMappings = {
    'relevance': 'Relevância',
    'price_desc': 'Maior Preço',
    'price_asc': 'Menor Preço',
    'relevance:desc': 'Relevância',
    'price:desc': 'Maior Preço',
    'price:asc': 'Menor Preço',
    'orders:desc': 'Mais Vendidos',
    'name:asc': 'A - Z',
    'name:desc': 'Z - A',
    'release:desc': 'Data de lançamento',
    'discount:desc': 'Melhor Desconto',
}

export type SortType =
    | 'price_desc'
    | 'price_asc'
    | 'price:desc'
    | 'price:asc'
    | 'relevance'
    | 'orders:desc'
    | 'name:desc'
    | 'name:asc'
    | 'release:desc'
    | 'discount:desc'
    | ''

// TODO: Replace with "search utils"
const applySort = (v: string, url: string) => {
    const theUrl = new URL(url)

    const urlSearchParams = new URLSearchParams(theUrl.search)

    urlSearchParams.set(SORT_QUERY_PARAM, v)
    theUrl.search = urlSearchParams.toString()

    return location.href = theUrl.toString()
}

export type Props = Pick<ProductListingPage, 'sortOptions'> & {
    url: string
    selectedSort?: string
    view?: 'list'
}

function Sort({ sortOptions, url, selectedSort, view }: Props) {
    const sort = selectedSort ?? new URLSearchParams(new URL(url).search).get(SORT_QUERY_PARAM) ??
        ''
    const index = sortOptions.findIndex(({ value }) => value === sort)

    const ss = sortOptions
        .map(({ value, label }) => ({
            value,
            label: portugueseMappings[label as keyof typeof portugueseMappings] ?? label,
        }))
        .filter(({ label }) => label)

    if (view === 'list') {
        return (
            <ul class='grid gap-y-5'>
                {ss.map(({ value, label }, i) => (
                    <li class='pl-5'>
                        <span
                            onClick={() => applySort(value, url)}
                            key={label}
                            role='option'
                            aria-selected={i === index}
                            id={label}
                            class='text-sm text-neutral-0'
                        >
                            {label}
                        </span>
                    </li>
                ))}
            </ul>
        )
    }

    return (
        <div class='flex items-center gap-2 flex-1'>
            <span class='font-lato text-sm text-neutral-0 hidden lg:block min-w-[77px]'>
                Ordenar por
            </span>
            <Select
                class='relative cursor-pointer border border-neutral-4 p-[11px] w-full lg:min-w-[190px]'
                title={
                    <div class='flex w-full items-center justify-between font-lato font-bold group'>
                        {portugueseMappings[
                            (sortOptions.find(({ value }) => value === sort)
                                ?.value as keyof typeof portugueseMappings) ?? 'relevance'
                        ]}
                        <Icon
                            id='Arrow'
                            width={17}
                            height={8}
                            class='transition-transform peer-checked:group-[]:rotate-180 text-primary-700'
                        />
                    </div>
                }
            >
                <Select.Options
                    activeId={ss[index]?.label ?? ''}
                    class='top-full -left-[1px] absolute box-content'
                    subClass='bg-white border-l border-b border-r border-neutral-4 box-content shadow-lg scrollbar-none'
                >
                    <div class='flex flex-col gap-y-2.5 p-[11px]'>
                        {ss.map(({ value, label }, i) => (
                            <span
                                // href={applySort(value, url)}
                                onClick={() => applySort(value, url)}
                                key={label}
                                role='option'
                                aria-selected={i === index}
                                id={label}
                                class='font-sm lg:text-xs font-lato text-neutral-0'
                            >
                                {portugueseMappings[value as keyof typeof portugueseMappings]}
                            </span>
                        ))}
                    </div>
                </Select.Options>
            </Select>
        </div>
    )
}

export default Sort
